import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketUserEmailCountBracketService {

    constructor(){

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);
        
        this.TICKET_USER_BRACKET = '/api/ticket-user-bracket';
        
        this.GET_LIST_BY_FORM = '/list/form/{formId}';

    }

    async getListByForm(formId) {
        try {
            let url = window.location.origin + this.TICKET_USER_BRACKET + this.GET_LIST_BY_FORM;
            url = url
                .replace('{formId}', formId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

}

export default TicketUserEmailCountBracketService;
